
import type { ProductVariant } from '~~/types/commercetools';
import {
  getProductAttributesExtended,
} from '~~/helpers/product/getProductAttributesExtended';

import getDeliveryDate from '~~/helpers/getDeliveryDate';
import { PRODUCT_ATTRIBUTES } from '~~/constants/products';
import {
  isParcelFeeApplying,
  getShippingRates,
  getShippingFeeDetails,
  getProductShippingMethod,
} from '~~/helpers/product/getProductShippingDetails';

const useProductShipping = (product: Ref<ProductVariant>) => {

  const { loadMethodsWithoutId, methodsWithoutId } = useShippingMethods();
  const { languageAndCountry, countryCode } = useLocalization();
  const { getPriceInformation } = useProductPrice();

  const { finalPrice } = getPriceInformation(product);

  const isFreightFeeApplied = computed(() => getProductAttributesExtended(
    product.value,
    {
      attributeNames: [PRODUCT_ATTRIBUTES.IS_PACKAGE_TYPE_FREIGHT],
    },
  )[PRODUCT_ATTRIBUTES.IS_PACKAGE_TYPE_FREIGHT]);
  const productShippingMethod = computed(() =>
    getProductShippingMethod(methodsWithoutId.value, !!isFreightFeeApplied.value),
  );

  const shippingFeeDetails = computed(() => {

    const shippingRate = getShippingRates(countryCode.value, productShippingMethod.value);

    return getShippingFeeDetails(shippingRate);
  
  });

  const isParcelFeeApplied = computed(() => isParcelFeeApplying(shippingFeeDetails.value, finalPrice.value));

  const deliveryDate = computed(() => getDeliveryDate(languageAndCountry.value, productShippingMethod.value));

  useLazyAsyncData(`shipping-methods`, async () => {

    await loadMethodsWithoutId();

    return '';
    
  });

  return {
    isFreightFeeApplied,
    isParcelFeeApplied,
    shippingFeeDetails,
    deliveryDate,
  };

};

export default useProductShipping;
